import PropTypes from "prop-types";
import SceErrorBox from "../../../Common/ErrorBox/sceErrorBox"; 
import classes from "./sceEmailText.scss";
import SceButton from "../../../Common/CommonComponents/sceButton";
class addVoiceTextBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultState: true, isValid: this.props.isValid, isError: this.props.isError, isTouched: false, value:this.props.emailValue, errorMsg: this.props.errorMsg, errDetails: null, isValidated: false, isDisabled: this.props.disabled, showHintIcon: false, toggleHideShow: false, isSdpLogin: this.props.isSdpLogin, isSdpServiceAccount: this.props.isSdpServiceAccount,
      email:"",
    };
    this.onChangeHandler = this.onChangeHandler.bind(this);
    this.onBlurHandler = this.onBlurHandler.bind(this);
    this.onFocusHandler = this.onFocusHandler.bind(this);
    this.onKeyPressHandler = this.onKeyPressHandler.bind(this);
    this.stateUpdaterHandler = this.stateUpdaterHandler.bind(this);
    this.toggleHideShowFunc = this.toggleHideShowFunc.bind(this);
    this.toggleHintText = this.toggleHintText.bind(this);
    this.mouseToggled = false; }
  /**updating props when new props are received */
  componentWillReceiveProps(nextProps) {
    // app.logger.getLogger().info('componentWillReceiveProps' + JSON.stringify(nextProps));
    const tempStateVarArr = ['isError', 'errorMsg', 'isDisabled', 'showHintIcon', 'isValid', 'forceValidate', 'prevPassword', 'accountNumber', 'isMasked'];
    let updatedStateObj = {};
    for (let stateVar of tempStateVarArr) {
      if (this.props[stateVar] !== nextProps[stateVar]) {
        updatedStateObj[stateVar] = nextProps[stateVar]; }
    }
    if (this.props['defaultValue'] !== nextProps['defaultValue']) {
      updatedStateObj['value'] = nextProps['defaultValue'];  }
    if (this.props['resetTextBox'] !== nextProps['resetTextBox'] && nextProps['resetTextBox']) {
      updatedStateObj = {
        defaultState: true, isValid: nextProps.isValid, isError: nextProps.isError, isTouched: false, value: nextProps.defaultValue,
        errorMsg: nextProps.errorMsg, errDetails: null, isValidated: false, isDisabled: nextProps.disabled, showHintIcon: false,
        toggleHideShow: false
      };}
    this.setState((prevState) => {
      return { ...prevState, ...updatedStateObj };
    }); }
  /**check if component updated */
  componentDidMount(){
    if(this.props.emailValue){
      this.setState({value:this.props.emailValue});
    }
  }
  componentDidUpdate() {
    // force validate the required fields if it is not validated
    if (this.props.forceValidate && !this.state.isValidated) {
      const defValue = this.props.defaultValue ? this.props.defaultValue : '';
      const params = { type: this.props.type, value: defValue, prevPassword: this.props.prevPassword, optional: this.props.optional, accountNumber: this.props.accountNumber, isMasked: this.props.isMasked };
      const errorStateObj = this.props.validator ? this.props.validator('onBlur', this.stateUpdaterHandler, null, params) : {};
      this.stateUpdaterHandler(errorStateObj, defValue);
    } 
  }
  /**
   * handle events on change and set the error state
   * @param event
   */
  onChangeHandler(e) {
    // app.logger.getLogger().info("onChange" + e);
    //e.preventDefault();
    const params = { type: this.props.type };
    let errorStateObj = this.props.validator ? this.props.validator('onChange', this.stateUpdaterHandler, e, params) || {} : {};
    errorStateObj = Object.keys(errorStateObj).length < 1 ? { isValid: false, isError: false } : errorStateObj;
    const textValue = e.target.value;
    
    //alert("t"+textValue);
    this.setState((prevState) => {
      return { ...prevState, ...errorStateObj, value: textValue };
    }); 
    this.props.addVoiceCallback(textValue);}
  /**
   * update state after Blur, check for icon required status and return the input field value,
   * errorFlag and validated state to parent
   * @param {*} stateObj
   * @param {*} value
   */
  stateUpdaterHandler(stateObj, value) {
    let updatedState;
    if (this.props.validator) {
      updatedState = stateObj ? (stateObj.isError ? { ...stateObj, isTouched: false } :
        { ...stateObj, isTouched: false }) : { isTouched: false };
    } else {
      updatedState = { defaultState: true, isError: false, isTouched: false }; }
    this.setState((prevState) => {
      return { ...prevState, ...updatedState, value: value };
    }, () => {
      if (!this.props.onTextUpdatedHandler) {
        return; }
      //send the inputted data to the parent user along with id of the textbox, its error and validated states
      let inputObj = {};
      inputObj.id = this.props.id;
      inputObj.value = this.state.value;
      inputObj.isError = this.state.isError;
      inputObj.isValidated = this.state.isValidated;
      if (stateObj) {
        inputObj.globalError = stateObj.globalError;}
      this.props.onTextUpdatedHandler(inputObj);
    });
  }
  /**
   * handle events on blur and set the error state
   * @param event
   */
  onBlurHandler(e) {
    //app.logger.getLogger().info("onBlur" + e);
    const params = { type: this.props.type, prevPassword: this.props.prevPassword, isServiceCallReq: this.props.isServiceCallReq, optional: this.props.optional, accountNumber: this.props.accountNumber, isMasked: this.props.isMasked };
    let errorStateObj = this.props.validator ? this.props.validator('onBlur', this.stateUpdaterHandler, e, params) || {} : {};
    this.stateUpdaterHandler(errorStateObj, e.target.value); }
  /**
   * handle events on focus and set the error state
   * @param event
   */
  onClickLogin=(e)=>{
    if(this.props.type === 'LoginUserIdEmail' || this.props.type === 'password'){
    document.getElementById("password").blur();
    window.setTimeout(() => {
      document.getElementById("innerloginHeaderLoginBtn").click();
    }, 100);
  }
}
  onFocusHandler(e) {
    // app.logger.getLogger().info("onfocus" + e);
    const params = { type: this.props.type };
    let errorStateObj = this.props.validator ? this.props.validator('onFocus', this.stateUpdaterHandler, e, params) || {} : {};
    // errorStateObj.isError = this.state.isError;
    // errorStateObj.isValid = this.state.isError;
    this.setState((prevState) => {
      return { ...prevState, ...errorStateObj, isTouched: true };
    });
    if (this.props.onFocusHandler) {
      let inputObj = {};
      inputObj.id = this.props.id;
      inputObj.value = this.state.value;
      inputObj.isError = this.state.isError;
      inputObj.isValidated = this.state.isValidated;
      this.props.onFocusHandler(inputObj);
    }
  }
  /**
   * handle keypress events
   * @param event
   */
  onKeyPressHandler(e) {
    // app.logger.getLogger().info("onKeyPress" + e);
    const params = { type: this.props.type };
    if (this.props.validator) {
      this.props.validator('onKeyPress', this.stateUpdaterHandler, e, params);
    }

    this.setState((prevState) => {
      return { ...prevState, isError: false, isValid: false };
    });
    if (e.key === 'Enter' || e.charCode === 13) {
      if (document.getElementById("resetPasswordValidateUser") && document.activeElement.id === "userIdEmail") {
        if (document.getElementById("btnResetPwdStep1Next")) {
          document.getElementById("userIdEmail").blur();
          window.setTimeout(() => { 
            document.getElementById("btnResetPwdStep1Next").click();
          } , 100);
            e.preventDefault();
        }
      }
      else if (this.props.isSdpLogin && document.getElementById("sdpLogin")) {
        document.getElementById("password").blur();
        window.setTimeout(() => {
          document.getElementById("sdpLogin").click();
        } , 100); }
      else if (this.props.isSdpServiceAccount && document.getElementById("NextButton")) {
        document.getElementById("serviceAccountNumber").blur();
        window.setTimeout(() => {
          document.getElementById("NextButton").click();
        } , 100); }
      else if (document.getElementById("innerloginHeaderLoginBtn")) {
       //call function
       this.onClickLogin();
      }
      if (document.getElementById('searchPhoneNumberBtn')) {
        document.getElementById("searchPhoneNumber").blur();
        window.setTimeout(() => {
          document.getElementById("searchPhoneNumberBtn").click();
        }, 100);
      }
       if(document.getElementById("react-header-login")){
        if(document.getElementById("password")|| document.getElementById("userName")){
        document.getElementById("password").blur();
        document.getElementById("userName").blur(); }
        window.setTimeout(()=>{ 
          if(document.getElementById("HomeLoginButton")){
          document.getElementById("HomeLoginButton").click();
        }else{
          document.getElementById("react-header-login").click(); }
         }
        ,100);    }
    }
    if (this.props.onKeyPressHandler) {
      this.props.onKeyPressHandler(e);// Added this as part of APA module.
    } }

  /**
   * toggle show hide button to mask/unmask text for password
  */
  toggleHideShowFunc(e) {
    this.setState((previousState) => {
      return { ...previousState, toggleHideShow: !(previousState.toggleHideShow) };
    });
  }
  /** toggle hint text on Click of hint icon*/
  toggleHintText(e) {
    this.setState((previousState) => {
      return { ...previousState, showHintIcon: !this.state.showHintIcon };
    }, () => { });
    e.preventDefault();
  }

  getValidStyle(state) {
    let validStyle;
    if (this.state.defaultState) {
      if (this.state.isError) {
        validStyle = 'sceInputError';
      } else if (this.state.isValid) {
        validStyle = 'sceInputSuccess';
      } else {
        validStyle = '';
      } }
    return validStyle;
  }

  onShowHideMouseDown(e) {
    app.logger.getLogger().info("onShowHideMouseDown::" + e.target);
    this.mouseToggled = true;
    this.toggleHideShowFunc(e);
  }
  onShowHideTouchEnd(e) {
    app.logger.getLogger().info("onShowHideTouchEnd::" + e.target);
    this.mouseToggled = true;
    this.toggleHideShowFunc(e);
  }
  onShowHideClick(e) {
    if (!this.mouseToggled) {
      this.toggleHideShowFunc(e);
    }
    e.preventDefault();
    this.mouseToggled = false;
  }
  setTextBoxType = () => {
    let textBoxType = this.props.isNumeric ? 'tel' : this.props.isEmail ? 'email' : 'text';
    if (this.props.hideText) {
      textBoxType = 'password';
    }
    if (['password', 'confirmPassword', 'newPassword', 'currentPassword', 'confirmPasswordReset', 'activationPassword', 'oldPassword'].includes(this.props.type)) {
      textBoxType = 'password';
    }
    return textBoxType;
  }

  /** render the textbox with its corresponding state */
  render() {
  //alert(this.props.emailValue);
    let hintMessage = this.props.children && this.props.children.props ? this.props.children.props.children : '';
    let textBoxType = this.setTextBoxType();
    const validStyle = this.getValidStyle(this.state);
    let validIconSpacing = '', validPwdSpacing = '';
    validIconSpacing = this.props.showHintIcon ? classes.sceTbIconPos : '';
    validPwdSpacing = this.props.showHintIcon ? (this.state.isValid ? classes.sceTbIconPosMax : classes.sceTbIconPos) : (this.state.isValid ? classes.sceTbIconPos : '');
   const passwordJSX = (textBoxType === 'password' && !this.props.hideText) ? <span className={[classes.sceInputLabel, validPwdSpacing].join(' ')}>
      <SceButton type="button" buttonType='sceFullGrey' value={this.state.toggleHideShow ? app.appUtil.t('Hide') : app.appUtil.t('Show')} onMouseDown={this.onShowHideMouseDown.bind(this)} onClick={this.onShowHideClick.bind(this)}
        />
    </span> : null;
    const showValidIconJSX = !this.state.isError && this.state.isValid ? <span className={[classes.sceRightIcon, validIconSpacing].join(' ')}>
      <i aria-hidden className='fas fa-check-circle fa-lg' />
      <span className="sr-only">Input valid</span>
    </span> : null;
    const hintJSX = this.props.showHintIcon && this.state.showHintIcon ? <div tabIndex='0' className={classes.sceInfoContent} role='region' aria-live='polite'>
      {hintMessage}
    </div> : null;
    const showHintIconJSX = this.props.showHintIcon ? <button type="button" aria-expanded="true" aria-label='show hint'   className={classes.sceBtnStyle} onClick={this.toggleHintText} >
      <i aria-hidden className={['far', 'fa-question-circle', 'fa-2x', classes.sceRightBtnIcon, classes.sceFontColorWhite].join(' ')} />
    </button> : null;
    return (
      <div>
        <div className={classes.sceFormContainer}> <div>
          <input
            className={[classes.sceTextBox, classes[validStyle]].join(' ')}
            maxLength={this.props.maxLength}
            type={this.state.toggleHideShow ? 'text' : textBoxType}
            id={this.props.id} width={this.props.width} placeholder={this.props.placeholder}  value={this.state.value}
            onChange={this.onChangeHandler.bind(this)} onBlur={this.onBlurHandler} onFocus={this.onFocusHandler}  onKeyPress={this.onKeyPressHandler}
            disabled={this.props.disabled} aria-label={this.props.id} aria-invalid={this.state.isError} aria-disabled={this.props.disabled} aria-required={!this.props.optional}
            autoComplete={this.props.autoComplete} name={this.props.name} />
             {/* <datalist id="data"  className={classes.sceDatalist}>{this.state.sampleMails.map((mail)=><option value={mail}>{mail}</option>)} </datalist>*/}
             </div> 
          {passwordJSX}
          {/* {showValidIconJSX} */}
          {showHintIconJSX}
          {/* Section to display Hint messages starts*/}
          {hintJSX}
          {/* Section to display Hint message ends*/}
          {/*Adding Error Comp here*/}
        </div>
        <SceErrorBox type={this.props.type} errDetails={this.state.errDetails} errorMessage={this.state.errorMsg}
          isError={this.state.isError} isTouched={this.state.isTouched} forceValidate={this.props.forceValidate}
          subType={this.props.subType} languageTranslations={this.props.languageTranslations} />
          </div>
    ); } }
/**default props for the component */
addVoiceTextBox.defaultProps = {type: 'text',placeholder: '',maxLength: null,defaultValue: '',disabled: false,forceValidate: false,isError: false,errorMsg: '',showHintIcon: false,resetTextBox: false,isValid: false,isServiceCallReq: false,optional: false,hideText: false,isNumeric: false,isEmail: false,languageTranslations: false};
/**prop types */
addVoiceTextBox.propTypes = {id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),type: PropTypes.string,placeholder: PropTypes.string,
  maxLength: PropTypes.number,disabled: PropTypes.bool,forceValidate: PropTypes.bool,onTextUpdatedHandler: PropTypes.func,onFocusHandler: PropTypes.func,defaultValue: PropTypes.string,validator: PropTypes.func,isError: PropTypes.bool,errorMsg: PropTypes.string,prevPassword: PropTypes.string,accountNumber: PropTypes.string,isMasked: PropTypes.bool,showHintIcon: PropTypes.bool,resetTextBox: PropTypes.bool,isValid: PropTypes.bool,isServiceCallReq: PropTypes.bool,optional: PropTypes.bool,hideText: PropTypes.bool,autoComplete: PropTypes.string,isNumeric: PropTypes.bool,isEmail: PropTypes.bool,name: PropTypes.string,languageTranslations: PropTypes.bool,isSdpLogin: PropTypes.bool,isSdpServiceAccount: PropTypes.bool
};
export default addVoiceTextBox;